// extracted by mini-css-extract-plugin
export default {"wrapper":"about-06_wrapper__XBCgw","container":"about-06_container__bN7gP"};